import React from 'react';
import { createSvgIcon } from '../../icon';
/* eslint-disable max-len */
export default createSvgIcon('arrow-forward', '0 0 32 32', React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M31.085 13.602L19.918 2.434c-.58-.579-1.499-.579-2.043 0-.58.579-.58 1.498 0 2.043l9.907 9.908H1.464c-.817 0-1.464.647-1.464 1.464s.647 1.464 1.464 1.464h26.318l-9.907 9.873c-.58.58-.58 1.498 0 2.043.272.272.647.409 1.021.409.375 0 .75-.137 1.022-.409L31.05 18.096a3.175 3.175 0 00.034-4.494z" })));
